import { FacingDirection } from "../../models/enumerations/facing-directions";
import { PainArea } from "../../models/enumerations/pain-area";
import { PainAreaMeta } from "../../models/enumerations/pain-area-meta";

// Optional but recommended: create a type-safe key type
export type PainAreaFacingKey = `${PainArea}_${FacingDirection}`;

export const PainAreaMap: Partial<Record<PainAreaFacingKey, PainAreaMeta>> = {
    // --- FRONT ---
    [`${PainArea.LeftShoulder}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.leftShoulder",
        facing: FacingDirection.FRONT,
        top: 50,
        left: 197,
        size: 30,
        labelSide: "right",
    },
    [`${PainArea.RightShoulder}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.rightShoulder",
        facing: FacingDirection.FRONT,
        top: 50,
        left: 123,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.Chest}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.chest",
        facing: FacingDirection.FRONT,
        top: 75,
        left: 160,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.RightArm}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.rightArm",
        facing: FacingDirection.FRONT,
        top: 120,
        left: 115,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.LeftArm}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.leftArm",
        facing: FacingDirection.FRONT,
        top: 120,
        left: 205,
        size: 30,
        labelSide: "right",
    },
    [`${PainArea.RightWrist}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.rightWrist",
        facing: FacingDirection.FRONT,
        top: 165,
        left: 110,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.LeftWrist}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.leftWrist",
        facing: FacingDirection.FRONT,
        top: 165,
        left: 210,
        size: 30,
        labelSide: "right",
    },
    [`${PainArea.RightHip}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.rightHip",
        facing: FacingDirection.FRONT,
        top: 150,
        left: 139,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.LeftHip}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.leftHip",
        facing: FacingDirection.FRONT,
        top: 150,
        left: 181,
        size: 30,
        labelSide: "right",
    },
    [`${PainArea.RightThigh}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.rightThigh",
        facing: FacingDirection.FRONT,
        top: 205,
        left: 139,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.LeftThigh}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.leftThigh",
        facing: FacingDirection.FRONT,
        top: 205,
        left: 181,
        size: 30,
        labelSide: "right",
    },
    [`${PainArea.RightKnee}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.rightKnee",
        facing: FacingDirection.FRONT,
        top: 250,
        left: 135,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.LeftKnee}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.leftKnee",
        facing: FacingDirection.FRONT,
        top: 250,
        left: 185,
        size: 30,
        labelSide: "right",
    },
    [`${PainArea.RightAnkle}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.rightAnkle",
        facing: FacingDirection.FRONT,
        top: 325,
        left: 128,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.LeftAnkle}_${FacingDirection.FRONT}`]: {
        label: "api.questions.pain.leftAnkle",
        facing: FacingDirection.FRONT,
        top: 325,
        left: 192,
        size: 30,
        labelSide: "right",
    },

    // --- BACK ---
    [`${PainArea.RightShoulder}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.rightShoulder",
        facing: FacingDirection.BACK,
        top: 50,
        left: 197,
        size: 30,
        labelSide: "right",
    },
    [`${PainArea.LeftShoulder}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.leftShoulder",
        facing: FacingDirection.BACK,
        top: 50,
        left: 123,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.Neck}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.neck",
        facing: FacingDirection.BACK,
        top: 33,
        left: 163,
        size: 24,
        labelSide: "left",
    },
    [`${PainArea.UpperBack}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.upperBack",
        facing: FacingDirection.BACK,
        top: 75,
        left: 160,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.LeftElbow}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.leftElbow",
        facing: FacingDirection.BACK,
        top: 120,
        left: 115,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.RightElbow}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.rightElbow",
        facing: FacingDirection.BACK,
        top: 120,
        left: 205,
        size: 30,
        labelSide: "right",
    },
    [`${PainArea.LowerBack}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.lowerBack",
        facing: FacingDirection.BACK,
        top: 130,
        left: 165,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.SiJoint}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.siJoint",
        facing: FacingDirection.BACK,
        top: 157,
        left: 165,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.LeftGlute}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.leftGlute",
        facing: FacingDirection.BACK,
        top: 170,
        left: 140,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.RightGlute}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.rightGlute",
        facing: FacingDirection.BACK,
        top: 170,
        left: 180,
        size: 30,
        labelSide: "right",
    },
    [`${PainArea.LeftHamstring}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.leftHamstring",
        facing: FacingDirection.BACK,
        top: 215,
        left: 137,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.RightHamstring}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.rightHamstring",
        facing: FacingDirection.BACK,
        top: 215,
        left: 183,
        size: 30,
        labelSide: "right",
    },
    [`${PainArea.LeftCalf}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.leftCalf",
        facing: FacingDirection.BACK,
        top: 280,
        left: 132,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.RightCalf}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.rightCalf",
        facing: FacingDirection.BACK,
        top: 280,
        left: 188,
        size: 30,
        labelSide: "right",
    },
    [`${PainArea.LeftAchilles}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.leftAchilles",
        facing: FacingDirection.BACK,
        top: 320,
        left: 129,
        size: 30,
        labelSide: "left",
    },
    [`${PainArea.RightAchilles}_${FacingDirection.BACK}`]: {
        label: "api.questions.pain.rightAchilles",
        facing: FacingDirection.BACK,
        top: 320,
        left: 191,
        size: 30,
        labelSide: "right",
    },
};

export const ReportPainAreaMap: Partial<Record<PainAreaFacingKey, PainAreaMeta>> = {
    // --- FRONT ---
    [`${PainArea.LeftShoulder}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.leftShoulder",
        facing: FacingDirection.FRONT,
        top: 32,
        left: 57,
        size: 20,
        labelSide: "right",
    },
    [`${PainArea.RightShoulder}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.rightShoulder",
        facing: FacingDirection.FRONT,
        top: 32,
        left: 8,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.Chest}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.chest",
        facing: FacingDirection.FRONT,
        top: 45,
        left: 33,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.RightArm}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.rightArm",
        facing: FacingDirection.FRONT,
        top: 73,
        left: 2,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.LeftArm}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.leftArm",
        facing: FacingDirection.FRONT,
        top: 73,
        left: 62,
        size: 20,
        labelSide: "right",
    },
    [`${PainArea.RightWrist}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.rightWrist",
        facing: FacingDirection.FRONT,
        top: 110,
        left: 2,
        size: 15,
        labelSide: "left",
    },
    [`${PainArea.LeftWrist}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.leftWrist",
        facing: FacingDirection.FRONT,
        top: 110,
        left: 67,
        size: 15,
        labelSide: "right",
    },
    [`${PainArea.RightHip}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.rightHip",
        facing: FacingDirection.FRONT,
        top: 100,
        left: 19,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.LeftHip}_${FacingDirection.FRONT}`]: { // 
        label: "api.questions.pain.leftHip",
        facing: FacingDirection.FRONT,
        top: 100,
        left: 46,
        size: 20,
        labelSide: "right",
    },
    [`${PainArea.RightThigh}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.rightThigh",
        facing: FacingDirection.FRONT,
        top: 135,
        left: 18,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.LeftThigh}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.leftThigh",
        facing: FacingDirection.FRONT,
        top: 135,
        left: 47,
        size: 20,
        labelSide: "right",
    },
    [`${PainArea.RightKnee}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.rightKnee",
        facing: FacingDirection.FRONT,
        top: 170,
        left: 15,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.LeftKnee}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.leftKnee",
        facing: FacingDirection.FRONT,
        top: 170,
        left: 50,
        size: 20,
        labelSide: "right",
    },
    [`${PainArea.RightAnkle}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.rightAnkle",
        facing: FacingDirection.FRONT,
        top: 215,
        left: 11,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.LeftAnkle}_${FacingDirection.FRONT}`]: { //
        label: "api.questions.pain.leftAnkle",
        facing: FacingDirection.FRONT,
        top: 215,
        left: 54,
        size: 20,
        labelSide: "right",
    },

    // --- BACK ---
    [`${PainArea.RightShoulder}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.rightShoulder",
        facing: FacingDirection.BACK,
        top: 32,
        left: 57,
        size: 20,
        labelSide: "right",
    },
    [`${PainArea.LeftShoulder}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.leftShoulder",
        facing: FacingDirection.BACK,
        top: 32,
        left: 8,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.Neck}_${FacingDirection.BACK}`]: { // 
        label: "api.questions.pain.neck",
        facing: FacingDirection.BACK,
        top: 25,
        left: 35,
        size: 15,
        labelSide: "left",
    },
    [`${PainArea.UpperBack}_${FacingDirection.BACK}`]: { // 
        label: "api.questions.pain.upperBack",
        facing: FacingDirection.BACK,
        top: 45,
        left: 33,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.LeftElbow}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.leftElbow",
        facing: FacingDirection.BACK,
        top: 73,
        left: 2,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.RightElbow}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.rightElbow",
        facing: FacingDirection.BACK,
        top: 73,
        left: 62,
        size: 20,
        labelSide: "right",
    },
    [`${PainArea.LowerBack}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.lowerBack",
        facing: FacingDirection.BACK,
        top: 87,
        left: 35,
        size: 15,
        labelSide: "left",
    },
    [`${PainArea.SiJoint}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.siJoint",
        facing: FacingDirection.BACK,
        top: 105,
        left: 35,
        size: 15,
        labelSide: "left",
    },
    [`${PainArea.LeftGlute}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.leftGlute",
        facing: FacingDirection.BACK,
        top: 115,
        left: 20,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.RightGlute}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.rightGlute",
        facing: FacingDirection.BACK,
        top: 115,
        left: 45,
        size: 20,
        labelSide: "right",
    },
    [`${PainArea.LeftHamstring}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.leftHamstring",
        facing: FacingDirection.BACK,
        top: 140,
        left: 17,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.RightHamstring}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.rightHamstring",
        facing: FacingDirection.BACK,
        top: 140,
        left: 48,
        size: 20,
        labelSide: "right",
    },
    [`${PainArea.LeftCalf}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.leftCalf",
        facing: FacingDirection.BACK,
        top: 188,
        left: 13,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.RightCalf}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.rightCalf",
        facing: FacingDirection.BACK,
        top: 188,
        left: 51,
        size: 20,
        labelSide: "right",
    },
    [`${PainArea.LeftAchilles}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.leftAchilles",
        facing: FacingDirection.BACK,
        top: 215,
        left: 11,
        size: 20,
        labelSide: "left",
    },
    [`${PainArea.RightAchilles}_${FacingDirection.BACK}`]: { //
        label: "api.questions.pain.rightAchilles",
        facing: FacingDirection.BACK,
        top: 215,
        left: 54,
        size: 20,
        labelSide: "right",
    },
};
